import {PermissionsData} from './permissions.data';
import {PermissionHelperModule} from '../core/PermissionHelperModule';

export class Permissions {
    static BreakRoute(route, route_info) {
        // check route params first
        const id = Permissions.CHeckRouteParams(route_info);
        // get option params
        route = route.split('?');
        if (route.length > 0) {
            route = route[0];
        }
        const split_route = route.split('/');
        let new_route = '';
        split_route.forEach(function (val, key) {
            if (val) {
                if (val != id) {
                    new_route += val + '.';
                }
            }
        });
        // remove last dot
        new_route = new_route.replace(/.\s*$/, '');
        return new_route;
    }

    static CheckRoute(route_data, route_info) {
        const route = Permissions.BreakRoute(route_data, route_info);
        if (route === 'home') {
            return true;
        }
        return PermissionHelperModule.CheckPermissionExist(PermissionsData.GetPermissions(route));
    }

    static CHeckRouteParams(route) {
        for (const val in route.params) {
            if (val) {
                return route.paramMap.params[val];
            }
        }
        return false;
    }
}
